'use client'

import { useEffect, useState } from 'react'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useIsAuthenticated, useIsBalanceLoaded } from 'src/store/player'

// Only escalate to the modal once loading has clearly stalled (slow operator
// wallet). For the common fast case the skeleton on the balance + disabled bet
// controls are enough, so the modal never appears.
const SHOW_AFTER_MS = 2_000

/**
 * Hybrid balance-loading affordance. While the real balance loads after a
 * non-blocking launch, betting is disabled and the balance shows a skeleton. If
 * it's taking unusually long, this small, non-blocking modal explains the wait.
 * It auto-dismisses the instant the balance lands.
 */
export function InitializingBalance() {
  const isAuthenticated = useIsAuthenticated()
  const isBalanceLoaded = useIsBalanceLoaded()
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const [show, setShow] = useState(false)

  const pending = isAuthenticated && !isBalanceLoaded

  useEffect(() => {
    if (!pending) {
      setShow(false)
      return
    }

    const timer = setTimeout(() => setShow(true), SHOW_AFTER_MS)
    return () => clearTimeout(timer)
  }, [pending])

  if (!pending || !show) return null

  return (
    <div className="initializing-balance" role="status" aria-live="polite">
      <div className="initializing-balance__panel">
        <span className="initializing-balance__spinner" aria-hidden="true" />
        <span className="initializing-balance__text">{t('Initializing balance')}</span>
      </div>
    </div>
  )
}
